// Plugin para gestionar traducciones

class Traductor {

  traducciones = {};
  traducciones_no_encontradas = [];

  establecerTraducciones (traducciones) {
    this.traducciones = traducciones || {};
  }

  guardarTraduccionesNoEncontradas() {
    let aux = "";
    this.traducciones_no_encontradas.forEach ((traduccion) => {
      aux = aux + traduccion + "\t\r\n";
    });
    localStorage.setItem (process.env.VUE_APP_ID + '.traducciones_no_encontradas', aux);
  }

  t (texto) {
    let textoClave = texto;
    let posicionPrimeraMayusculaEnClave = textoClave.search(/[A-ZÑÁÉÍÓÚ]/); // primera letra mayúscula
    if ([0, 1].includes (posicionPrimeraMayusculaEnClave) && (texto[posicionPrimeraMayusculaEnClave+1] != texto [posicionPrimeraMayusculaEnClave+1].toUpperCase())) {
      textoClave = textoClave.slice (0, posicionPrimeraMayusculaEnClave) + textoClave [posicionPrimeraMayusculaEnClave].toLowerCase() + textoClave.slice (posicionPrimeraMayusculaEnClave + 1);
    }

    let traduccion = this.traducciones [textoClave];
    if (!traduccion) {
      if (!this.traducciones_no_encontradas.includes (textoClave)) {
        this.traducciones_no_encontradas.push (textoClave);
        this.guardarTraduccionesNoEncontradas();
      }
      traduccion = texto;
    } else if (traduccion == '~') {
      traduccion = texto;
    } else {
      let posicionPrimeraLetraEnTraduccion = traduccion.search(/[A-Za-zÑñÁáÉéÍíÓóÚú]/); // primera letra
      if ([0, 1].includes (posicionPrimeraLetraEnTraduccion)) {
        if ([0, 1].includes (posicionPrimeraMayusculaEnClave))
          traduccion = traduccion.slice (0, posicionPrimeraLetraEnTraduccion) + traduccion [posicionPrimeraLetraEnTraduccion].toUpperCase() + traduccion.slice (posicionPrimeraLetraEnTraduccion + 1);
        else
          traduccion = traduccion.slice (0, posicionPrimeraLetraEnTraduccion) + traduccion [posicionPrimeraLetraEnTraduccion].toLowerCase() + traduccion.slice (posicionPrimeraLetraEnTraduccion + 1);
      }
    }
    //return "-"; // descomentar para visualizar facilmente que cadenas se están traduciendo...
    return traduccion;
  }
}

export default {
  install (Vue) {
    Vue.prototype.$traductor = new Traductor ();
    Vue.prototype.$t = function (texto) { return Vue.prototype.$traductor.t (texto); };
  }
}